(() => {
  if (customElements.get('runway-editorial')) return;
  customElements.define('runway-editorial', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.runway-editorial-track');
      this.dots = this.querySelector('.runway-editorial-dots');
      if (!this.track || !this.dots) return;
      this.abort = new AbortController();
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.slides = Array.from(this.track.children);
      this.dots.replaceChildren(...this.slides.map((slide, index) => {
        const dot = document.createElement('span');
        dot.className = 'runway-editorial-dot';
        dot.setAttribute('role', 'img');
        dot.setAttribute('aria-label', `Imagen ${index + 1} de ${this.slides.length}`);
        return dot;
      }));
      const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: this.abort.signal });
      listen(this.track, 'scroll', () => this.updateDots());
      listen(this.mobile, 'change', () => this.updateLayout());
      listen(this.track, 'keydown', event => {
        if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const next = Math.max(0, Math.min(this.slides.length - 1, this.currentIndex() + (event.key === 'ArrowRight' ? 1 : -1)));
        this.showSlide(next);
      });
      listen(document, 'shopify:block:select', event => {
        const slide = event.target.closest('.runway-editorial-image');
        const index = this.slides.indexOf(slide);
        if (this.mobile.matches && index >= 0) this.showSlide(index);
      });
      this.resizeObserver = new ResizeObserver(() => this.updateDots());
      this.resizeObserver.observe(this.track);
      this.updateLayout();
    }
    currentIndex() {
      return this.slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - this.track.scrollLeft) < Math.abs(this.slides[best].offsetLeft - this.track.scrollLeft) ? index : best, 0);
    }
    updateDots() {
      const current = this.currentIndex();
      Array.from(this.dots.children).forEach((dot, index) => {
        if (index === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    updateLayout() {
      this.dots.hidden = !this.mobile.matches || this.slides.length < 2;
      this.track.setAttribute('tabindex', this.mobile.matches ? '0' : '-1');
      if (this.mobile.matches) this.track.setAttribute('aria-roledescription', 'carrusel');
      else {
        this.track.removeAttribute('aria-roledescription');
        this.track.scrollTo({ left: 0, behavior: 'auto' });
      }
      this.updateDots();
    }
    showSlide(index) {
      if (!this.slides[index]) return;
      this.track.scrollTo({ left: this.slides[index].offsetLeft, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
    }
  });
})();
